import React, { Component, Fragment } from 'react';
import { Grid, Form } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { Field, reduxForm, getFormValues, change } from 'redux-form';
import { withRouter } from 'react-router';
import moment from 'moment';

import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { TitledCard } from 'Components';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CASE_TYPE_REPORT_FORM_NAME } from 'Common/FormEnum';
import { CaseTypeReportFieldEnum as Fields } from 'Common/FieldEnum';
import { YesNoOptions } from 'Common/FormHelper';
import { SiteSelectField } from 'Common/ReduxFormFields';

import {
  getGradesAction,
  getCaseTypesAction,
} from '../state/casetypereport/actions';

class CaseTypeReportFormContainer extends Component {
  DCCatOptions = [
    { label: 'All', value: 'All' },
    { label: 'DC', value: 'DC' },
    { label: 'DC Extended Benefit', value: 'DCExtended' },
    { label: 'Categorical', value: 'Categorical' },
    { label: 'Categorical Extended Benefit', value: 'CategoricalExtended' },
  ];

  SortByOptions = [
    { label: 'Last name, First', value: 'LastnameFirst' },
    { label: 'School / Last name', value: 'SchoolLastname' },
    { label: 'Family #', value: 'Family' },
    { label: 'School / Grade / Last name', value: 'SchoolGradeLastname' },
  ];

  GroupByOptions = [
    { label: 'District', value: 'district' },
    { label: 'Site', value: 'site' },
  ];

  componentDidMount() {
    this.props.getGradesAction();
    this.props.getCaseTypesAction();
  }

  componentDidUpdate(prevProps, prevState) {
    const { formValues } = this.props;
    if (
      formValues[Fields.SiteGroup] !== prevProps.formValues[Fields.SiteGroup]
    ) {
      this.setState({ filterSites: this.filterSites() });
    }
  }

  render() {
    const { formValues, grades, caseTypes, loading } = this.props;

    const gradeOptions = (grades && grades.length > 1
      ? [{ value: 'ALL', key: -1, text: 'ALL' }]
      : []
    ).concat(
      grades
        ? grades.map((grade, i) => ({
            value: grade.Id,
            key: i,
            text: `${grade.Id} ${grade.Description}`,
          }))
        : []
    );

    const caseTypeOptions = (caseTypes && caseTypes.length > 1
      ? [
          { value: 'ALL', key: -2, text: 'ALL' },
          { value: 0, key: -1, text: 'NONE' },
        ]
      : [{ value: 0, key: -1, text: 'NONE' }]
    ).concat(
      caseTypes
        ? caseTypes
            .filter((caseType) => caseType.Description.length > 0)
            .map((caseType, i) => ({
              value: caseType.Id,
              key: i,
              text: `${caseType.Description}`,
            }))
        : []
    );

    return (
      <Fragment>
        <Form name={CASE_TYPE_REPORT_FORM_NAME}>
          <Grid>
            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Report Settings">
                  <Grid className={'caseTypeReport-settingGrid'}>
                    <Grid.Row style={{ height: '100px' }}>
                      <Grid.Column>
                        <Field
                          label={'As of Student Effective Date'}
                          name={Fields.AsOfDate}
                          component={DatePickerField}
                          type="text"
                          openToDate={moment()}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column
                        className="input-group--btn-group"
                        widescreen={3}
                        mobile={4}
                      >
                        <ReduxFormButtonGroup
                          label={'Summary Only?'}
                          options={YesNoOptions}
                          formName={CASE_TYPE_REPORT_FORM_NAME}
                          value={formValues[Fields.SummaryOnly]}
                          fieldName={Fields.SummaryOnly}
                          disabled={loading}
                          onChange={(isSummaryOnly) => {
                            if (
                              isSummaryOnly &&
                              formValues[Fields.Site] !== 'ALL'
                            ) {
                              this.props.change(
                                CASE_TYPE_REPORT_FORM_NAME,
                                Fields.GroupBy,
                                'site'
                              );
                            }
                            if (!isSummaryOnly) {
                              this.props.change(
                                CASE_TYPE_REPORT_FORM_NAME,
                                Fields.GroupBy,
                                'district'
                              );
                            }
                          }}
                        />
                      </Grid.Column>
                      <Grid.Column
                        className="input-group--btn-group"
                        widescreen={3}
                        mobile={4}
                      >
                        <ReduxFormButtonGroup
                          label={'Group By'}
                          options={this.GroupByOptions}
                          formName={CASE_TYPE_REPORT_FORM_NAME}
                          fieldName={Fields.GroupBy}
                          disabled={
                            loading ||
                            formValues[Fields.Site] !== 'ALL' ||
                            !formValues[Fields.SummaryOnly]
                          }
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'Sort By'}
                          options={this.SortByOptions}
                          formName={CASE_TYPE_REPORT_FORM_NAME}
                          value={formValues[Fields.SortBy]}
                          fieldName={Fields.SortBy}
                          disabled={loading || formValues[Fields.SummaryOnly]}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <TitledCard title="Filter By">
                  <Grid>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <Field
                          component={SiteSelectField}
                          name={Fields.Site}
                          disabled={loading}
                          onChange={(newSite) => {
                            if (
                              newSite !== 'ALL' &&
                              formValues[Fields.SummaryOnly]
                            ) {
                              this.props.change(
                                CASE_TYPE_REPORT_FORM_NAME,
                                Fields.GroupBy,
                                'site'
                              );
                            }
                          }}
                        ></Field>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <Field
                          name={Fields.CaseType}
                          component={SelectField}
                          type="text"
                          label="Case Types"
                          options={caseTypeOptions}
                          disabled={loading}
                          className={'short'}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <Field
                          name={Fields.Grade}
                          component={SelectField}
                          type="text"
                          label="Grade"
                          options={gradeOptions}
                          disabled={loading}
                          className={'shorter'}
                        />
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column className="input-group--btn-group">
                        <ReduxFormButtonGroup
                          label={'DC / Cat'}
                          options={this.DCCatOptions}
                          formName={CASE_TYPE_REPORT_FORM_NAME}
                          value={formValues[Fields.DCCat]}
                          fieldName={Fields.DCCat}
                          loading={loading}
                          disabled={loading}
                        />
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </TitledCard>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Form>
      </Fragment>
    );
  }
}

const validate = (values) => {
  const errors = {};

  if (!moment(values[Fields.AsOfDate]).isValid()) {
    errors[Fields.AsOfDate] = 'Enter a valid Effective Date.';
  }
  if (!values[Fields.AsOfDate]) {
    errors[Fields.AsOfDate] = 'Effective Date must be set.';
  }
  if (!values[Fields.Site]) {
    errors[Fields.Site] = 'Site must be set.';
  }
  if (!values[Fields.CaseType].toString().length) {
    errors[Fields.CaseType] = 'Case Type must be set.';
  }
  if (!values[Fields.Grade]) {
    errors[Fields.Grade] = 'Grade must be set.';
  }

  return errors;
};

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues(CASE_TYPE_REPORT_FORM_NAME)(state),
    loading: state.CaseTypeReportState.caseTypeReport.loading,
    grades: state.CaseTypeReportState.caseTypeReport.grades.Data,
    caseTypes: state.CaseTypeReportState.caseTypeReport.caseTypes.Data,
  };
};

const mapDispatchToProps = { getCaseTypesAction, getGradesAction, change };

const CaseTypeReportForm = reduxForm({
  form: CASE_TYPE_REPORT_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(
  withRouter(
    connect(mapStateToProps, mapDispatchToProps)(CaseTypeReportFormContainer)
  )
);

export { CaseTypeReportForm };



// WEBPACK FOOTER //
// ./src/pages/casetype/components/CaseTypeReportForm.js